<template>
    <transition
        enter-active-class="transition ease-out duration-500"
        :enter-from-class="transitionFrom"
        :enter-to-class="transitionTo"
        leave-active-class="transition ease-in duration-250"
        :leave-from-class="transitionTo"
        :leave-to-class="transitionFrom"
    >
        <div
            @scroll="onScroll"
            v-if="value"
            class="w-full"
            :class="['app-overlay', bgComputed, scrollable ? 'overflow-y-auto' : 'flex flex-col h-full w-full']"
        >
            <slot v-bind="{isBottom}"></slot>
        </div>
    </transition>

    <!-- <transition name="fade" v-if="value">
        <div class="modal-backdrop"></div>
    </transition> -->
</template>

<script>
import PropsHelper from "@/helper/PropsHelper"

export default {
    name: "FullScreenDialog",
    props: {
        modelValue: {
            type: Boolean
        },
        hideOverlay: {
            type: Boolean,
            default: false
        },
        overlayClass: {
            type: String,
            default: 'overlay-dark'
        },
        bg: {
            type: String, default: undefined
        },
        scrollable: {
            type: Boolean,
            default: true
        },
        bottom: { type: Boolean },
        right: { type: Boolean }
    },
    emits: [],
    data: function () {
        return {
            isBottom: false,
        }
    },
    computed: {
        value: {
            get: function () {
                return this.modelValue
            },
            set: function (newVal) {
                this.$emit("update:modelValue", newVal)
            }
        },
        bgComputed: function () {
            return PropsHelper.getStringProp(this.bg)
        },
        transitionFrom: function () {
            let transition = "transform translate-y-full"

            if (this.right) {
                transition = "transform translate-x-full"
            }

            return transition
        },
        transitionTo: function () {
            let transition = "transform translate-y-0"

            if (this.right) {
                transition = "transform translate-x-0"
            }

            return transition
        }
    },
    watch: {
        value: function (val) {
            if (val) {
                this.isBottom = false
                document.body.classList.add('not-scroll')
            }else{
                document.body.classList.remove('not-scroll')
            }
        }
    },
    methods: {
        setDefault: function () {
            this.isBottom = false;
        },
        onScroll: function (event) {
            // console.log(event.target.scrollHeight); // ความสูงของ content
            // console.log(event.target.scrollTop + event.target.offsetHeight); // ความสูงที่เรา scroll + ความสูงของจอ
            if (event.target.scrollTop + event.target.offsetHeight >= event.target.scrollHeight - 180) {

                this.isBottom = true;
            } else {
                this.isBottom = false;
            }
        },
        disableScroll: function () {
            // modern Chrome requires { passive: false } when adding event
            // https://stackoverflow.com/questions/4770025/how-to-disable-scrolling-temporarily
            // var supportsPassive = false;
            // try {
            //     window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
            //         get: function () {
            //             supportsPassive = true;
            //             return true
            //         }
            //     }));
            // } catch (e) {
            //     // do nothing
            // }

            // var wheelOpt = supportsPassive ? { passive: false } : false;
            // var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

            // window.addEventListener('DOMMouseScroll', this.preventDefault, false); // older FF
            // window.addEventListener(wheelEvent, this.preventDefault, wheelOpt); // modern desktop
            // window.addEventListener('touchmove', this.preventDefault, wheelOpt); // mobile
            // window.addEventListener('keydown', this.preventDefaultForScrollKeys, false);
            // window.onscroll = function () { window.scrollTo(0, 0); };
            var x = window.scrollX;
            var y = window.scrollY;
            window.onscroll = function () { window.scrollTo(x, y); };
        },
        enableScroll: function () {
            window.onscroll = function () { };
        },
        preventDefault: function (e) {
            e.preventDefault();
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
</style>
